imperialDistanceUnit:
    en: 'Miles'
    es: 'Millas'
    pt: 'Milhas'
    ru: 'Мили'
    fr: ''
metricDistanceUnit:
    en: 'Kilometers'
    es: 'Kilómetros'
    pt: 'Quilometros'
    ru: 'Километры'
m:
    en: minutes
    es: minutos
    pt: minutos
    ru: минут
    fr: minutes
s:
    en: seconds
    es: segundos
    pt: segundos
    ru: секунд
    fr: secondes
ms:
    en: milliseconds
    es: milisegundos
    pt: milissegundos
    ru: миллисекунд
    fr: millisecondes
dynamic:
    en: Dynamic
    es: Dinámico
    pt: Dinâmico
    ru: Динамические
    fr: Dynamique
static:
    en: Fixed
    es: Fijo
    pt: Fixo
    ru: Фиксированные
    fr: Fixe
updateLandmarkByDriverResponse: # tooltip usage (change both)
    en: 'By driver response'
    es: 'Por respuesta del conductor'
    pt: 'Respostado conductor'
    ru: 'По ответу водителя'
updateLandmarkAutomatically: # tooltip usage (change both)
    en: Automatically
    es: Automáticamente
    pt: Automático
    ru: Автоматически
updateLandmarkTurnOff:
    en: 'Turn off'
    es: Apagado
    pt: Desligado
    ru: Отключить
attachmentTransportPhotoWifi:
    en: 'Wi-Fi only'
    es: 'Solo Wi-Fi'
    pt: 'Apenas Wi-Fi'
    ru: 'Только Wi-Fi'
attachmentTransportPhotoAlways:
    en: 'Mobile data and Wi-Fi (immediate upload)'
    es: 'Datos móviles y Wi-Fi (carga inmediata)'
    pt: 'Dados móveis e Wi-Fi (upload imediato)'
    ru: 'Мобильные данные и Wi-Fi (немедленная загрузка)'
widgetExternal:
    en: 'On the Maxoptra domain'
    es: 'En el dominio de Maxoptra'
    pt: 'No domínio da Maxoptra'
    ru: 'На домене Максоптра'
widgetInternal:
    en: 'On your customer website'
    es: 'En su página web'
    pt: 'Em seu site'
    ru: 'На собственном сайте'
SchedulingZoneMode.OFF:
    en: 'Without territories'
    es: Apagado
    fr: Off
    pt: 'Sem territórios'
    ru: 'Планировать без учета территорий'
SchedulingZoneMode.USE_TERRITORIES:
    en: 'Use territories'
    es: 'Usar territorios'
    fr: 'Utiliser les territoires'
    pt: 'Usar territórios'
    ru: 'Планировать по отдельным территориям'
SchedulingZoneMode.USE_TERRITORY_GROUPS:
    en: 'Use groups of territories'
    es: 'Usar grupos de territorios'
    fr: 'Utiliser les groupes de territoires'
    pt: 'Usar grupos de territórios'
    ru: 'Планировать по группам территорий'
